import { formFieldKeys } from '@messenger/consts'
import { isEmpty } from 'lodash'
import isDate from 'utils/dates/isDate'

type DetermineCaseDetailTypeProps = {
  value: string
  initialText: string
  path: string
}

export const determineCaseDetailType = ({
  value,
  initialText,
  path,
}: DetermineCaseDetailTypeProps) => {
  // Determine the value type for the renderer
  const isPlaceholder = initialText.includes('{$')
  let type = 'string'

  if (isEmpty(value)) type = 'empty'
  if (isDate(value)) type = 'date'
  if (isPlaceholder) type = 'placeholder'

  // Special handling for empty name fields
  const nameFields = [
    formFieldKeys.prefix,
    formFieldKeys.firstName,
    formFieldKeys.nickName,
    formFieldKeys.middleName,
    formFieldKeys.maidenName,
    formFieldKeys.lastName,
    formFieldKeys.suffix,
  ] as const
  if ((nameFields as readonly string[]).includes(path) && isEmpty(value)) {
    type = 'emptyName'
  }

  return type
}
